@if (contact) {
  <app-summary-section
    [stepRoute]="contactRoute"
    heading="COMMISSIONING_ELECTRICITY.CONTACT.CONTACT_DETAILS"
  >
    <p class="section-heading">
      {{ "COMMISSIONING_ELECTRICITY.CONTACT.CONNECTION_RECIPIENT" | translate }}
    </p>

    <div class="section-fields-container">
      <app-contact-details
        [contactDetails]="contact.requesterDetails.basicData"
      />
    </div>

    <div class="section-fields-container">
      <app-summary-section-field
        [value]="
          (contact.requesterDetails.hasDifferentAddress
            ? 'COMMON.NO'
            : 'COMMON.YES'
          ) | translate
        "
        label="COMMISSIONING_ELECTRICITY.CONTACT.CONNECTION_ADDRESS_QUESTION"
      />
    </div>

    @if (contact.requesterDetails.hasDifferentAddress) {
      <p class="section-heading">
        {{
          "COMMISSIONING_ELECTRICITY.CONTACT.RESIDENTIAL_ADDRESS_TITLE"
            | translate
        }}
      </p>

      @if (contact.requesterDetails.differentAddress) {
        <div class="section-fields-container">
          <app-address [address]="contact.requesterDetails.differentAddress" />
        </div>
      }
    }

    <p class="section-heading">
      {{
        "COMMISSIONING_ELECTRICITY.CONTACT.ELECTRICAL_SPECIALIST_COMPANY"
          | translate
      }}
    </p>
    <div class="section-fields-container">
      <app-contact-details
        [contactDetails]="contact.electricianDetails.basicData"
      />

      <app-summary-section-field
        [value]="contact.electricianDetails.gridOperator"
        label="CONTACT.INSTALLER.GRID_OPERATOR"
      />
      <app-summary-section-field
        [value]="contact.electricianDetails.registrationNumber"
        label="CONTACT.INSTALLER.REGISTRATION_NUMBER"
      />
      <app-summary-section-field
        [value]="contact.electricianDetails.companyName"
        label="CONTACT.INSTALLER.COMPANY_NAME"
      />
    </div>

    <div class="section-fields-container">
      <app-address [address]="contact.electricianDetails.address" />
    </div>
    <div
      id="commissioning-electricity-contact-date"
      class="section-fields-container"
    >
      <app-summary-section-field
        [value]="
          (contact.electricianDetails.date
            | date: 'shortDate' : '' : currentLanguageCulture) || '-'
        "
        label="COMMISSIONING_ELECTRICITY.CONTACT.DATE"
      />
    </div>

    <p class="section-heading">
      {{ "CONTACT.POWER_OF_ATTORNEY.TITLE" | translate }}
    </p>

    <div class="section-fields-container">
      <app-summary-section-field
        [value]="
          (contact.electricianDetails.powerOfAttorney
            ? 'COMMON.YES'
            : 'COMMON.NO'
          ) | translate
        "
        label="CONTACT.POWER_OF_ATTORNEY.DECLARATION"
      />
      @if (contact.electricianDetails.powerOfAttorneyDocument) {
        <app-summary-section-field
          [value]="contact.electricianDetails.powerOfAttorneyDocument.name"
          label="CONTACT.POWER_OF_ATTORNEY.DOCUMENT"
        />
      }
    </div>
  </app-summary-section>
}
